import { render, staticRenderFns } from "./annotation-sort.vue?vue&type=template&id=cc34c06a"
import script from "./annotation-sort.vue?vue&type=script&lang=js"
export * from "./annotation-sort.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports